<ion-card class="review-card" *ngIf="!initloading">
    <ion-row>
        <ion-col size="12" size-xs="12" size-sm="12" size-md="12" size-lg="12" size-xl="4">
            <ion-slides [options]="sliderOpts" pager="true" *ngIf="status?.application?.program?.image.length > 0">
                <ion-slide *ngFor="let pic of images; let i = index">
                    <img class="program-image" [src]="pic | img : status?.application?.program?.state : 'md'" />
                </ion-slide>
            </ion-slides>

            <ion-slides [options]="sliderOpts" *ngIf="status?.application?.program?.image.length === 0">
                <ion-slide>
                    <img class="program-image" [src]="status?.application?.program?.image | img : status?.application?.program?.state : 'md'" />
                </ion-slide>
            </ion-slides>
        </ion-col>
        <ion-col class="ion-justify-content-center" size="12" size-xs="12" size-sm="12" size-md="12" size-lg="12" size-xl="12">
            <div class="title-container ion-text-center no-background">
                <ion-label class="title">Review {{ status?.application?.name }}</ion-label>
            </div>
            <ion-list>
                <ion-item class="ion-text-center" lines="none">
                    <ion-label class="application-label">
                        <fa-icon [icon]="icons.case"></fa-icon>
                        {{ status?.application?.specialty }}
                    </ion-label>
                </ion-item>
                <ion-item class="ion-text-center" lines="none">
                    <ion-label class="application-label ion-text-wrap">
                        <fa-icon [icon]="icons.calendar"></fa-icon>
                        {{ status.application?.startdate | date : 'longDate' : 'UTC' }}
                        -
                        {{ status?.application?.enddate | date : 'longDate' : 'UTC' }}
                    </ion-label>
                </ion-item>
            </ion-list>
            <p class="required-text">
                {{ (toolService.content | async)?.application?.components?.review?.bottomcardcontent }}
            </p>
        </ion-col>
    </ion-row>
    <ion-card-content class="review-content">
        <div *ngIf="noQuestions" class="ion-text-center">
            <p class="bold-text">We are not able to receive question now</p>
        </div>
        <form [formGroup]="review_form" (ngSubmit)="submit()">
            <ion-list *ngFor="let question of reviewQuestions; let i = index">
                <span [ngSwitch]="question?.type">
                    <div *ngSwitchCase="'string'">
                        <ion-item-divider>
                            <ion-label class="ion-text-wrap">
                                <p [innerHTML]="question?.question + '*'" class="question-label"></p>
                                <ion-note style="font-size: 0.9em"> Maximum of 500 characters </ion-note>
                            </ion-label>
                        </ion-item-divider>
                        <ion-item class="inputItem" lines="none">
                            <ion-textarea rows="7" maxlength="550" [formControlName]="question?.question"></ion-textarea>
                        </ion-item>
                    </div>

                    <div *ngSwitchCase="'boolean'">
                        <ion-item lines="none" class="select-questions">
                            <ion-label class="question-label form-title ion-text-wrap select-title" position="stacked">
                                <div [innerHTML]="question.question + '*'"></div>
                            </ion-label>
                            <ion-select class="basic-select" okText="Ok" cancelText="Dismiss" [formControlName]="question?.question">
                                <ion-select-option [value]="true">Yes</ion-select-option>
                                <ion-select-option [value]="false">No</ion-select-option>
                            </ion-select>
                        </ion-item>
                    </div>

                    <div *ngSwitchCase="'number'">
                        <ion-item-divider lines="none">
                            <ion-label class="ion-text-wrap">
                                <p [innerHTML]="question?.question + '*'" class="question-label"></p>
                            </ion-label>
                        </ion-item-divider>
                        <ion-item lines="none">
                            <star-rating-control #rating readonly="false" [formControlName]="question?.question"> </star-rating-control>
                        </ion-item>
                    </div>

                    <div *ngSwitchDefault>
                        <p>need type</p>
                    </div>
                </span>
            </ion-list>
            <div class="ion-text-center">
                <ion-button class="half-button" [disabled]="loading" color="primary" type="submit"> Submit Review</ion-button>
            </div>
        </form>
    </ion-card-content>
</ion-card>
<ion-card class="review-card" *ngIf="initloading">
    <ion-list>
        <ion-list-header>
            <ion-label>
                <ion-skeleton-text animated style="width: 20%"></ion-skeleton-text>
            </ion-label>
        </ion-list-header>
        <ion-item>
            <ion-avatar slot="start">
                <ion-skeleton-text animated></ion-skeleton-text>
            </ion-avatar>
            <ion-label>
                <h3>
                    <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
                </h3>
                <p>
                    <ion-skeleton-text animated style="width: 80%"></ion-skeleton-text>
                </p>
                <p>
                    <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
                </p>
            </ion-label>
        </ion-item>
        <ion-item>
            <ion-thumbnail slot="start">
                <ion-skeleton-text animated></ion-skeleton-text>
            </ion-thumbnail>
            <ion-label>
                <h3>
                    <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
                </h3>
                <p>
                    <ion-skeleton-text animated style="width: 80%"></ion-skeleton-text>
                </p>
                <p>
                    <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
                </p>
            </ion-label>
        </ion-item>
        <ion-item>
            <ion-skeleton-text animated style="width: 27px; height: 27px" slot="start"></ion-skeleton-text>
            <ion-label>
                <h3>
                    <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
                </h3>
                <p>
                    <ion-skeleton-text animated style="width: 80%"></ion-skeleton-text>
                </p>
                <p>
                    <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
                </p>
            </ion-label>
        </ion-item>
    </ion-list>
</ion-card>
<!-- [disabled]="!review_form.valid" -->
